module.exports = __webpack_public_path__ + "static/media/DSC00592.02d2ba33.jpg";